import React, { useState } from 'react';
import { Button, Input } from 'edozvola-frontend-lib/dist/ui/components';
import ConstructionTable from 'app/edozvola/cases/construction-building-procedure/constructions/construction-table';
import ConstructionForm from './construction-form';
import { Label } from 'edozvola-frontend-lib/dist/ui';
import { useFormik } from 'formik';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useParams } from 'react-router-dom';
import { copyConstructionsFromCaseQuery } from 'app/edozvola/cases/construction-building-procedure/service/construction-building-procedure.queries';
import { caseWebIdToCopyFromSchema } from '../construction-building-procedure.schema';
import { Col, Row } from 'reactstrap';
import { CASE_TAB_ENUM } from 'app/config/constants';
import ConstructionFormV2 from './construction-form-v2';
import { PaginatedDropdown } from 'edozvola-frontend-lib/dist/ui/components/paginated-dropdown';
import { getCaseContext } from 'app/shared/util/context-util';

const Constructions = ({
  constructionNumberOptions,
  isConstructionNumberOptionLoading,
  selectedConstructionNumberOption,
  setConstructionNumberOptions,
  formik,
  variant,
}) => {
  const { id: uuid } = useParams<{ id: string }>();
  const [idConstruction, setIdConstruction] = useState<string | null>(null);
  const [readOnly, setReadOnly] = useState(false);
  const { sidebarItemPair } = getCaseContext();

  const copyConstructionsFormik = useFormik({
    initialValues: { caseWebIdToCopyFrom: '' },
    validationSchema: caseWebIdToCopyFromSchema,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: values => copyConstructions(values.caseWebIdToCopyFrom),
  });

  const { mutate: copyConstructions, isPending: isCopyConstructionsPending } = copyConstructionsFromCaseQuery(
    uuid,
    variant,
    copyConstructionsFormik.resetForm,
  );

  const openConstructionForm = () => {
    setIdConstruction('');
    setReadOnly(false);
  };

  return (
    <>
      <h6 className="form-header mb-0">Građevina</h6>
      <div className={'pt-4 pb-4'}>
        <Row>
          <Col md={5}>
            <Label labelText={'Broj građevina'} />
            <PaginatedDropdown
              placeholder={!sidebarItemPair?.readOnly && 'Odaberi broj građevina'}
              onItemSelect={setConstructionNumberOptions}
              selected={selectedConstructionNumberOption}
              labelKey={'value'}
              options={isConstructionNumberOptionLoading ? [] : constructionNumberOptions}
              disabled={sidebarItemPair?.readOnly}
              error={!sidebarItemPair?.readOnly && (formik.errors.constructionNumber as string)}
              showErrorMessage
            />
          </Col>
        </Row>
      </div>
      {!sidebarItemPair?.readOnly && (
        <>
          <div className={'d-flex justify-content-end pb-4 gap-2'}>
            <div className={'case-copy-from-other-case'}>
              <Input
                placeholder={'Unesite šifru predmeta'}
                maxLength={255}
                addonAppend={
                  isCopyConstructionsPending ? (
                    <FontAwesomeIcon icon="spinner" spin />
                  ) : (
                    <FontAwesomeIcon
                      aria-disabled={
                        (!!copyConstructionsFormik.errors && !!copyConstructionsFormik.errors.caseWebIdToCopyFrom) ||
                        copyConstructionsFormik.values.caseWebIdToCopyFrom === ''
                      }
                      className={
                        (!!copyConstructionsFormik.errors && !!copyConstructionsFormik.errors.caseWebIdToCopyFrom) ||
                        copyConstructionsFormik.values.caseWebIdToCopyFrom === ''
                          ? 'disabled'
                          : ''
                      }
                      icon="copy"
                    />
                  )
                }
                value={copyConstructionsFormik.values.caseWebIdToCopyFrom}
                onChange={event => {
                  copyConstructionsFormik.setFieldValue('caseWebIdToCopyFrom', event.target.value);

                  if (copyConstructionsFormik.submitCount > 0) {
                    copyConstructionsFormik.setErrors({});
                  }
                }}
                addonAppendClick={() => {
                  if (!isCopyConstructionsPending) {
                    copyConstructionsFormik.handleSubmit();
                  }
                }}
                error={
                  copyConstructionsFormik.errors && copyConstructionsFormik.errors.caseWebIdToCopyFrom
                    ? copyConstructionsFormik.errors.caseWebIdToCopyFrom
                    : ''
                }
              />
            </div>
            <div>
              <Button label={'Dodaj građevinu'} color={'info'} prependIcon={'plus'} size={'lg'} onClick={openConstructionForm} />
            </div>
          </div>
        </>
      )}
      <ConstructionTable setIdConstruction={setIdConstruction} setReadOnly={setReadOnly} variant={variant} />

      {idConstruction !== null && (
        <>
          {variant === CASE_TAB_ENUM.CONSTRUCTION_BUILDING_PROCEDURE && (
            <ConstructionForm
              readOnly={readOnly}
              setIdConstruction={setIdConstruction}
              idConstruction={idConstruction}
              variant={CASE_TAB_ENUM.CONSTRUCTION_BUILDING_PROCEDURE}
            />
          )}
          {variant === CASE_TAB_ENUM.CONSTRUCTION_BUILDING_PROCEDURE_V2 && (
            <ConstructionFormV2
              readOnly={readOnly}
              setIdConstruction={setIdConstruction}
              idConstruction={idConstruction}
              variant={CASE_TAB_ENUM.CONSTRUCTION_BUILDING_PROCEDURE_V2}
            />
          )}
        </>
      )}
    </>
  );
};

export default Constructions;
